import React, { Component, Fragment } from "react";
import { Dialog, FormHelperText, Grid, TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { Formik } from "formik";
import { LabeledButtonMultiple, FormikInputTypeAhead, PrimaryButton, SecondaryButton, ButtonSizeOptions, DEAL_PROJECT_TYPES } from '@loanbossinc/component-library';
import inputComponentMask from "lib/inputMask";

const PaddedDiv = styled.div`
  padding: 30px 10px 10px 30px;
`;

const styles = () => ({
  dialogTitle: {
    color: "blue",
    padding: "30px 0 0 30px"
  },
  labelRoot: {},
  inputField: {
    borderBottom: "1px solid #2196F3",
  },
  error: {
    '& input': {
      borderBottom: '1px solid red'
    }
  }
});

const StyledFormikInputTypeAhead = styled(FormikInputTypeAhead)`
  border-bottom: 1px solid #2196F3;
  width: 100%;
`
const StyledLabeledButtonMultiple = styled(LabeledButtonMultiple)`
  margin-top: 2em;
  margin-left: 38px
`;

const StyledDialog = styled(Fragment)`
  width: 480px;
  height: 477px;
`;

const StyledPrimaryButton = styled(PrimaryButton)`
  &&&{
    margin-left: 24px;
  }`;

const StyledTitle = styled.div`
  //styleName: Work Sans / 24;
  font-family: Work Sans;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0em;
  text-align: left;
  padding-left: 20px;
  padding-top: 20px;
 `;

class DealModal extends Component {
  constructor(props) {
    super(props);
  }

  closeModal = () => this.props.onClose();
  onCancel = () => this.props.onClose();

  save = item => {
    this.props.onSave(item);
    this.closeModal();
  }

  getDealProjectTypeOptions = (deal, handleChange) => ([
    {
      label: 'Construction',
      onClick: () => {
        deal.projectTypeId = DEAL_PROJECT_TYPES.CONSTRUCTION;
        handleChange();
      },
      iconName: "build",
      selected: deal && deal.projectTypeId && deal.projectTypeId === DEAL_PROJECT_TYPES.CONSTRUCTION,
    },
    {
      label: 'Value-Add',
      onClick: () => {
        deal.projectTypeId = DEAL_PROJECT_TYPES.VALUE_ADD;
        handleChange();
      },
      iconName: "home_work",
      selected: deal && deal.projectTypeId && deal.projectTypeId === DEAL_PROJECT_TYPES.VALUE_ADD,
    },
    {
      label: 'Stabilized',
      onClick: () => {
        deal.projectTypeId = DEAL_PROJECT_TYPES.STABILIZED;
        handleChange();
      },
      iconName: "home",
      selected: deal && deal.projectTypeId && deal.projectTypeId === DEAL_PROJECT_TYPES.STABILIZED,
    }
  ]);

  handleDealGroupChange = (value) => {
    if (!value) this.formik.current.setFieldValue("dealGroupId", null);
  }

  render() {

    const modalTitle = "Create New Deal";

    const {
      classes,
      deal,
      dealGroups,
      isOpen,
    } = this.props;

    return (
      <StyledDialog>
        <Dialog
          open={isOpen}
          onClose={this.closeModal}
          fullWidth
          maxWidth="sm"
          id="dealModel">
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between">
            <StyledTitle id="dealModelHeader">
              {modalTitle}
            </StyledTitle>
          </Grid>
          <PaddedDiv>
            <Formik
              initialValues={{ ...deal }}
              validateOnChange={false}
              validate={values => {
                const { name } = values;
                let errors = {};
                if (!name) errors.name = "Required";
                return errors;
              }}
              onSubmit={(values) => this.save(values)}
              render={({ values, errors, handleChange, handleBlur, handleSubmit }) => (
                <>
                  <Grid container direction="row">
                    <Grid container item={true} xs={11}>
                      <TextField
                        InputProps={{
                          classes: {
                            input: classes.inputField,
                            error: classes.error,
                          },
                          disableUnderline: true,
                        }}
                        InputLabelProps={{
                          FormLabelClasses: {
                            root: classes.labelRoot,
                          }
                        }}
                        fullWidth
                        required
                        id="dealModelNameField"
                        name="name"
                        label="Deal Name"
                        value={values.name}
                        error={!!errors.name}
                        onChange={handleChange} />
                      {!!errors.name && <FormHelperText id={errors.id}>{errors.name}</FormHelperText>}
                    </Grid>
                    <Grid container item={true} xs={11}>
                      <StyledFormikInputTypeAhead
                        id='dealGroupId'
                        name='dealGroupId'
                        label="Group Name"
                        options={dealGroups}
                        displayWith={(option) => option && option.name}
                        setValueWith={(option) => option && option.id}
                        onChange={(value) => this.handleDealGroupChange(value)}
                        className="input" />
                    </Grid>
                    {this.props.hasBrokerAccess &&
                      <Grid container item={true} xs={11}>
                        <StyledFormikInputTypeAhead
                          id='sponsorCompanyId'
                          name='sponsorCompanyId'
                          label="Sponsor Company *"
                          options={this.props.sponsorCompanies}
                          displayWith={(option) => option && option.name}
                          setValueWith={(option) => option && option.id}
                          onChange={handleChange}
                          className="input" />
                      </Grid>}
                    <Grid container item={true} xs={11}>
                      <StyledLabeledButtonMultiple options={this.getDealProjectTypeOptions(values, handleBlur)} />
                    </Grid>
                    <Grid container item={true} xs={11}>
                      <>
                        {
                          values.projectTypeId === DEAL_PROJECT_TYPES.CONSTRUCTION &&
                          <TextField
                            InputProps={{
                              inputComponent: inputComponentMask({
                                mask: "currency"
                              }),
                              classes: {
                                input: classes.inputField,
                                error: classes.error,
                              },
                              disableUnderline: true,
                            }}
                            InputLabelProps={{
                              FormLabelClasses: {
                                root: classes.labelRoot,
                              }
                            }}
                            fullWidth
                            id="estDevelopmentCost"
                            name="estDevelopmentCost"
                            label="Estimated Development Cost"
                            defaultValue={Number}
                            error={!!errors.name}
                            onChange={handleChange} />
                        }
                        {
                          (values.projectTypeId === DEAL_PROJECT_TYPES.VALUE_ADD ||
                            values.projectTypeId === DEAL_PROJECT_TYPES.STABILIZED) &&
                          <TextField
                            InputProps={{
                              inputComponent: inputComponentMask({
                                mask: "currency"
                              }),
                              classes: {
                                input: classes.inputField,
                                error: classes.error,
                              },
                              disableUnderline: true,
                            }}
                            InputLabelProps={{
                              FormLabelClasses: {
                                root: classes.labelRoot,
                              }
                            }}
                            fullWidth
                            id="pricingGuidance"
                            name="pricingGuidance"
                            label="Pricing Guidance"
                            error={!!errors.name}
                            onChange={handleChange} />
                        }
                        {!!errors.name && <FormHelperText id={errors.id}>{errors.name}</FormHelperText>}
                      </>
                    </Grid>
                  </Grid>
                  <Grid container direction="row" justify="flex-end">
                    <SecondaryButton label="Cancel" size={ButtonSizeOptions.sm} onClick={this.onCancel} style={{ marginTop: '16px' }} />
                    <StyledPrimaryButton disabled={!values.projectTypeId || !values.name || (this.props.hasBrokerAccess && !values.sponsorCompanyId)} label="Create" size={ButtonSizeOptions.sm} onClick={handleSubmit} style={{ marginTop: '16px' }} />
                  </Grid>
                </>
              )}
            />
          </PaddedDiv>
        </Dialog>
      </StyledDialog>
    );
  }
}

export default withStyles(styles)(DealModal);
